<!-- Banner Section -->

<div class="image_outer" [ngStyle]="{'background-image': 'url('+imageURL + ')'}">
  <div class="img_opacity"></div>
  <div class="image_text">
    <span id="imageText_size_header">{{selectedNaacName}}</span><br>
  </div>
</div>
<!--MAP SECTION -->
<div class="container-fluid mapBorder">
  <div class="mapContainer ">
    <div class="bpgHeading">
    </div>
    <div class="labelHeading">
      <span class="dataCount" *ngIf="totalSites!= null && totalSites!= undefined"> {{totalSites}} <label
          class="labelName">Sites </label></span>
      <span class="dataCount" *ngIf="totalChapters!= null && totalChapters!= undefined"> {{totalChapters}} <label
          class="labelName">Chapters</label> </span>
      <span class="dataCount" *ngIf="totalMembershipCount!= null && totalMembershipCount!= undefined">
        {{totalMembershipCount}} <label class="labelName">Memberships</label></span>
    </div>
    <div class="row  map-row">
      <!-- Code for displaying USA MAP -->
      <div class="col-md-4  map ">
        <div class="form-group">
        </div>
        <div #areaMapCanada></div>
      </div>
      <!-- Code for displaying Canada MAP -->
      <div class="col-md-4 mapmargin ">
        <div class="form-group">
        </div>
        <div #areaMapUSA></div>
      </div>
      <!-- Code for displaying Mexico MAP -->
      <div class="col-md-4 mapmargin ">
        <div class="form-group">
        </div>
        <div #areaMapMexico></div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4 column">
          <div class="vission">
            <h3>VISION</h3>
            <i aria-hidden="true" style="font-size: 30px;margin-bottom: 8px"></i>
          </div>
          <p *ngIf="visionStatement" class="para" [innerHtml]="sanitizer.bypassSecurityTrustHtml(visionStatement)"></p>
        </div>
        <div class="col-md-4 column_mission">
          <div class="vission">
            <h3>AFFINITY GOALS</h3>
            <i aria-hidden="true" style="font-size: 30px;margin-bottom: 8px"></i>
          </div>
          <p *ngIf="affinityGoal" class="para" [innerHtml]="sanitizer.bypassSecurityTrustHtml(affinityGoal)"></p>
        </div>
        <div class="col-md-4 naac_logo">
          <img src='{{naacLogo}}' style="height:100%;width: 100%;" alt="Angular Logo">
        </div>
      </div>
    </div>
    <!-- Resource and news section -->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6 additional_bpg_outerdiv" [ngClass]="{'hideDesc_2': !flag2}">

          <h3 class="additional_heading">NAAC RESOURCES</h3>

          <div *ngFor="let resourceInfo of selectedFolder,let i=index;">
            <div class="resourceTitle"><a class="resorce_underline"
                (click)="selectnaacFolder(resourceInfo.folderId)">{{resourceInfo.Maxmin}}
              </a>{{resourceInfo.folderName}}
            </div>
            <span *ngIf="resourceInfo.showFolder">
              <span *ngFor="let file of fileList,let j=index;">
                <div class="filename"><a class="files" (click)="downloadAttachments(file.naacResourceDocument,j)"
                    downloadAttachments-btn id='downloadFiles{{j}}'>{{file.naacResourceTitle}}</a></div>
              </span> </span>

          </div>
        </div>
        <div class="col-md-6 full_description_outerdiv bpg_news_outerdiv">
          <span class="news_heading">LATEST NAAC NEWS</span>

          <!-- <marquee behavior="scroll" class="scroll" direction="up" scrollamount="1" scrolldelay="12"
            truespeed="truespeed" onmouseover="this.stop()" onmouseout="this.start()"> -->
          <div class="news-scroller-header">
            <div class="news-scroll" id="newsId">
            <!-- class="news-scroll"> -->
              <span>&nbsp;</span>
              <div *ngFor="let newsInfo of selectedNewsList">
                <div>
                  <img src="{{newsInfo.naacNewsUrl}}" class="news_image" alt="Angular Logo">

                </div>
                <div class="title_main_div side-left ">
                  <div class="news_title ">{{newsInfo.naacNewsTitle}}</div>
                  <div class="news_create_time">{{newsInfo.modifiedDateTime | date:'MM-dd-yyyy'}}</div>
                </div>

                <div class="news_description_div side-left">
                  <p class="news_description" *ngIf="newsInfo.showFullWord">{{newsInfo.naacNewsDesc}} </p>
                  <p class="news_description" *ngIf="!newsInfo.showFullWord">{{newsInfo.minWord}} </p>
                  <span class="viewmore" (click)=showFullDesc(newsInfo.naacNewsId) *ngIf="!newsInfo.showFullWord"> View
                    More</span>
                  <span
                    *ngIf="(newsInfo.naacNewsDesc==null || newsInfo.naacNewsDesc==undefined || newsInfo.naacNewsDesc=='')">
                    &nbsp;</span>
                </div>
                <div
                  *ngIf="(newsInfo.naacNewsLink== '' || newsInfo.naacNewsLink==undefined || newsInfo.diNewsLink== null)">
                  &nbsp;</div>
                <div class="news_link_div side-left"
                  *ngIf="newsInfo.naacNewsLink!= null && newsInfo.naacNewsLink.substring(0,4) =='http'">
                  <a class="news_link" href="{{newsInfo.naacNewsLink}}" target="_blank" rel="noopener">{{newsInfo.naacNewsLink.length >
                  35 ?
                  newsInfo.naacNewsLink.slice(0,35)+'...' : newsInfo.naacNewsLink}}</a>
                </div>
                <div class="news_link_div side-left"
                  *ngIf="newsInfo.naacNewsLink!= null  && newsInfo.naacNewsLink.substring(0,4) !='http'">
                  <a class="news_link" href="http://{{newsInfo.naacNewsLink}}" target="_blank">{{newsInfo.naacNewsLink.length
                  > 35 ? newsInfo.naacNewsLink.slice(0,35)+'...' : newsInfo.naacNewsLink}}</a>
                </div>

                <hr>
              </div>
            </div>
          </div>
          <!-- </marquee> -->

        </div>
      </div>


    </div>

    <!-- Display Naac Summary -->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 summary_outerdiv" *ngIf="(adminId=='1' || adminId=='4' || isNaacAdmin)">
          <div class="summary_head">NAAC DASHBOARD</div>
          <div class="summarySection">
            <div class="summaryDropdown">
              <ng-select placeholder="All Chapters" [items]="siteListforBpg" name="siteName" bindLabel="siteName"
                class="custom" bindValue="siteId" [(ngModel)]="selectedSite" (change)="getnaacSummary(checkYear)">
              </ng-select>
            </div>
            <div class="summaryRadio">
              <input type="radio" class="radio-input-align" value="currentFiscalYear" [(ngModel)]="checkYear"
                (click)="getnaacSummary('currentFiscalYear')"> FY{{currentYearDisplay}}
              <input type="radio" class="radio-input-align radio-input-margin" value="nextFiscalYear"
                [(ngModel)]="checkYear" (click)="getnaacSummary('nextFiscalYear')"> FY{{nextYearDisplay}}
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 summary_heading ">
              <span class="data_heading">HOSHINS</span>
              <div class="memberGroup" *ngIf="(selectedSite == 0)">
                <div class="hoshinCount">{{summaryDetails.budgetSubmittedCount}}
                  <span class="hoshinLabel">Submitted</span>
                  <span class="tooltiptext" *ngIf="(summaryDetails.budgetSubmittedCount > 0)">Sites :
                    {{summaryDetails.submittedSiteName}}</span>
                </div>
                <div class="hoshinCount">{{summaryDetails.budgetApprovedCount}}
                  <span class="hoshinLabel">Approved</span>
                  <span class="tooltiptext" *ngIf="(summaryDetails.budgetApprovedCount > 0)">Sites :
                    {{summaryDetails.approvedSiteName}}</span>
                </div>
                <div class="hoshinCount">{{summaryDetails.budgetNewCount}}
                  <span class="hoshinLabel">New</span>
                  <span class="tooltiptext" *ngIf="(summaryDetails.budgetNewCount > 0)">Sites :
                    {{summaryDetails.newSiteName}}</span>
                </div>
                <div class="hoshinCount">{{summaryDetails.budgetRejectedCount}}
                  <span class="hoshinLabel">Rejected</span>
                  <span class="tooltiptext" *ngIf="(summaryDetails.budgetRejectedCount > 0)">Sites :
                    {{summaryDetails.rejectedSiteName}}</span>
                </div>
              </div>
              <div
                *ngIf="(selectedSite != 0 && hoshinStatus != null && hoshinStatus!= undefined && !summaryDetails.noHoshin)">
                <div class="hoshinStatus"> Status : <label class="MemberCount">{{hoshinStatus}}</label>
                </div>

              </div>
              <div
                *ngIf="(selectedSite != 0 && hoshinStatus != null && hoshinStatus!= undefined && summaryDetails.noHoshin)">
                <div class="hoshinStatus"><label class="MemberCount">{{hoshinStatus}}</label>
                </div>

              </div>
              <div
                *ngIf="(selectedSite != 0 && chapterEmail != null && chapterEmail != undefined && chapterEmail != '')">
                <button type="button" class="btn btn-danger margin-save" (click)="contactUs()">CONTACT US</button>
              </div>
            </div>
            <!-- <div class="col-md-4  summary_heading">
              <span class="data_heading">BUDGET</span>
              <div class="memberGroup">
                <div class="MemberCount">$ {{summaryDetails.approvedBudgetCount}}<label class="summarylabelName">Hoshin
                    Approved Budget</label> </div>
                <div class="MemberCount">{{summaryDetails.numberOfRequests}}<label class="summarylabelName">Total
                    Requests</label></div>
                <div class="MemberCount">$ {{summaryDetails.totalExpense}}<label class="summarylabelName">
                    Budget Spend</label> </div>

              </div>
            </div> -->
            <div class="col-md-4  summary_heading">
              <span class="data_heading">HOSHIN INITIATIVE</span>
              <div class="memberGroup">
                <div class="MemberCount">{{summaryDetails.totalHoshinInitiativeCount}}<label class="summarylabelName">
                    Total <span *ngIf="summaryDetails.totalHoshinInitiativeCount!=0">(
                      {{summaryDetails.totalPercentage}}%)</span></label> </div>
                <div class="MemberCount">{{summaryDetails.hoshinInitiativeAchievedCount}}<label
                    class="summarylabelName">
                    Achieved <span *ngIf="summaryDetails.totalHoshinInitiativeCount!=0">(
                      {{summaryDetails.achievedPercentage}}%)</span></label> </div>
                <div class="MemberCount">{{summaryDetails.hoshinInitiativePartiallyMetCount}}<label
                    class="summarylabelName">
                    Partially Met <span *ngIf="summaryDetails.totalHoshinInitiativeCount!=0">(
                      {{summaryDetails.partiallyMetPercentage}}%)</span></label></div>
                <div class="MemberCount">{{summaryDetails.hoshinInitiativeIncompleteCount}}<label
                    class="summarylabelName">
                    Incomplete <span *ngIf="summaryDetails.totalHoshinInitiativeCount!=0">(
                      {{summaryDetails.incompletePercentage}}%)</span></label> </div>
              </div>
            </div>
            <div class="col-md-4  summary_heading">
              <span class="data_heading">EVENTS</span>
              <div class="memberGroup">
                <div class="MemberCount event-sec"> {{summaryDetails.totalEventsCount}}<label
                    class="summarylabelName">Events</label></div>
                <div class="MemberCount event-sec">{{summaryDetails.registeredEventsCount}}<label
                    class="summarylabelName">Registered</label></div>
                <div class="MemberCount event-sec">{{summaryDetails.attendedEventsCount}}<label
                    class="summarylabelName">Attended</label></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- NAAC Committee Section -->
      <div class="container-fluid"
        *ngIf="selectedReTeamList != null && selectedReTeamList != undefined && selectedReTeamList.length > 0">
        <div class="row">

          <h3 class="col-md-12" id="engagementTeam">NAAC BOARD</h3>
          <div class="reteam engagement_div" *ngFor="let reTeaminfo of selectedReTeamList">
            <div>
              <img src={{reTeaminfo.userPic}} alt="" class="picture">
            </div>
            <div class="userdetails">
              <div class="username">{{reTeaminfo.userName}} </div>
              <div class="rolename" style="font-family: 'Montserrat-Regular',sans-serif;">{{reTeaminfo.roleName}}</div>
              <div class="rolename"><span class="fa fa-envelope" style="color:#b62027 ;">
                  <a class="email" href="mailto:{{reTeaminfo.emailId}}">{{reTeaminfo.emailId}}</a></span></div>
              <div class="rolename"
                *ngIf="(reTeaminfo.siteName!= null && reTeaminfo.siteName!= '' && reTeaminfo.siteName!= undefined)">
                <span class="siteLabel"> Location :</span>
                <span class="siteValue">{{reTeaminfo.siteName}}</span>
              </div>

              <div class="rolename"
                *ngIf="(reTeaminfo.naacPronounce != null && reTeaminfo.naacPronounce != '' && reTeaminfo.naacPronounce != undefined)">
                <span class="siteLabel">Pronouns :</span>
                <span class="siteValue">{{reTeaminfo.naacPronounce }}</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- large screen -->
      <div id="upcomingevents_web">
        <div class="container-fluid">
          <div class="row map-row">
            <div class="col-md-6 upcoming_events_outerdiv">
              <h2 class="upcoming_events_margin">UPCOMING EVENTS</h2>
              <div id="eventlist{{i}}" class="list-group listgroup_margin" [ngClass]="{'hideDiv': i > 2}"
                *ngFor="let events of upcoming_events_info; let i = index" (click)="openeventsDetails(events.eventId)">
                <div *ngIf="i <= 2">
                  <div class="date_span">
                    <div class="event_day">{{events.eventDay}}</div>
                    <div class="event_monthname">{{events.eventMonth}}</div>

                  </div>
                  <div class="content_span_font">
                    <span class="event_name_font_weight">{{events.eventName}}</span><br>
                    <span>{{events.startTime}}</span> - <span>{{events.endTime}}</span><span><span> |
                      </span>{{events.venue}}</span><br>
                    <span>{{events.siteName}} | {{events.naacAffinityName}}</span>
                  </div>
                  <div id="eventlist{{i}}{{i}}" class="icon-arrowleft-div" [ngClass]="{'hideDiv': i >= 1}">
                    <i class="fa fa-caret-left arrow-left-i" aria-hidden="true"></i>
                  </div>


                </div>
              </div>

              <a class="viewmoreevents_anchor" *ngIf="upcoming_events_info != null && upcoming_events_info.length>=3"
                (click)="viewMoreEvents()">View more events >></a>

            </div>
            <div class="col-md-6 upcoming_events_outerdiv evnt_detls_outerdiv">
              <h2 class="upcoming_events_margin eventname_clor" *ngIf="upcoming_events_info">{{eventName}}</h2>
              <p class="eventdetails_clor" *ngIf="upcoming_events_info">{{event_details}}</p>

              <input type="hidden" class="form-control" name="eventId" [(ngModel)]="event_id">
              <a class="viewmoreeventsdeatils_anchor" (click)="viewMoreEventsDetails(event_id)"
                *ngIf="(upcoming_events_info != undefined && this.upcoming_events_info.length!=0)">View details >></a>

            </div>
          </div>
        </div>
      </div>


      <!-- small screen -->
      <div id="upcomingevents_mob" class="marginBottom">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 upcoming_events_outerdiv"
              [ngClass]="{'hide-for-mobile': (upcoming_events_info != undefined && upcoming_events_info.length < 1)}">
              <h2 class="upcoming_events_margin">UPCOMING EVENTS</h2>
              <div id="eventlist{{i}}" class="list-group listgroup_margin" [ngClass]="{'hideDiv': i > 2}"
                *ngFor="let events of upcoming_events_info; let i = index" (click)="openeventsDetails(events.eventId)">
                <div *ngIf="i <= 2">
                  <div class="date_span">
                    <div class="event_day">{{events.eventDay}}</div>
                    <div class="event_monthname">{{events.eventMonth}}</div>

                  </div>
                  <div class="content_span_font">
                    <span class="event_name_font_weight">{{events.eventName}}</span><br>
                    <span>{{events.startTime}}</span> - <span>{{events.endTime}}</span><span><span> |
                      </span>{{events.venue}}</span><br>
                    <span>{{events.siteName}} | {{events.naacAffinityName}}</span>
                  </div>

                </div>
              </div>
              <a class="viewmoreevents_anchor" *ngIf="upcoming_events_info != null && upcoming_events_info.length>=3"
                (click)="viewMoreEvents()">View more events >></a>

            </div>
            <div class="col-md-12 upcoming_events_outerdiv evnt_detls_outerdiv">
              <h2 class="upcoming_events_margin eventname_clor" *ngIf="upcoming_events_info">{{eventName}}</h2>
              <p class="eventdetails_clor" id="event_description_div" *ngIf="upcoming_events_info">{{event_details}}</p>

              <input type="hidden" class="form-control" name="eventId" [(ngModel)]="event_id">
              <a class="viewmoreeventsdeatils_anchor" (click)="viewMoreEventsDetails(event_id)"
                *ngIf="(upcoming_events_info != undefined && this.upcoming_events_info.length!=0)">View details >></a>

            </div>
          </div>
        </div>
      </div>
